import * as React from 'react'
import { Button, Header, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

type BuyGroupProps = {
  money: number,
}

export const DepositLink: React.SFC<BuyGroupProps> = (props) => {
  const moneyString = props.money.toLocaleString('vn') + ' vnd'
  return (
    <Segment textAlign="center">
      <Header>
        Bạn cần nạp thêm số tiền {moneyString}
      </Header>
      <Button.Group>
        <Button primary={true} as={Link} to={`/user/depositBank?amount=${props.money}`}>Chuyển khoản</Button>
        <Button.Or/>
        <Button primary={true} as={Link} to={`/user/nl?amount=${props.money}`}>Ngân Lượng</Button>
      </Button.Group>
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/RollItemStore/components/DepositLink.tsx